<template>
  <form-drawer title="配置年份" :visible="dialogVisible" width="520px" :loading="saveLoading" @update:visible="handleDrawerVisible" @save="handleSaveDialog">
    <el-form :model="form" :rules="rules" ref="form" label-position="right" label-width="150px" size="small" class="drawer-horizontal-form">
      <el-form-item label="ID" prop="id">
        <el-input v-model.number="form.id" :disabled="type" style="width: 100%" placeholder="请输入 ID"></el-input>
      </el-form-item>
      <el-form-item label="年份" prop="year">
        <el-input v-model.number="form.year" placeholder="请输入年份 (如: 2026)"></el-input>
      </el-form-item>
    </el-form>
  </form-drawer>
</template>

<script>
import api from '@/api/channel'
import FormDrawer from '@/components/FormDrawer/index.vue'

export default {
  name: 'HolidayDialog',
  components: { FormDrawer },
  props: {
    dialogVisible: Boolean,
    holidayData: Object
  },
  watch: {
    holidayData: function (val) {
      this.type = !!val.year // true 为修改，false 为新增
      const data = Object.assign({}, val)
      this.form = data
    }
  },
  data () {
    return {
      form: {
        id: this.holidayData.id
      },
      type: '',
      saveLoading: false,
      rules: {
        id: [{
          type: 'number',
          required: true,
          message: '请输入数字，且不能为空',
          trigger: 'change'
        }],
        year: [{
          type: 'number',
          required: true,
          message: '请输入数字，且不能为空',
          trigger: 'change'
        }]
      }
    }
  },
  methods: {
    handleCloseHolidayDialog () {
      if (this.$refs.form) this.$refs.form.clearValidate()
      this.$emit('handleCloseHolidayDialog', false)
    },
    handleDrawerVisible (visible) {
      if (!visible) this.handleCloseHolidayDialog()
    },
    handleSaveDialog () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveLoading = true
          const params = Object.assign({}, this.form)
          const f = this.type ? api.updateHoliday : api.addHoliday
          f(params).then(res => {
            this.$message.success(this.type ? '修改成功' : '添加成功')
            this.$emit('handleSaveHolidayDialog', res)
          }).finally(() => {
            this.saveLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped></style>
